import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../translations/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t } = useLanguage();

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/packages', label: t('nav.packages') },
    { path: '/gallery', label: t('nav.gallery') },
    { path: '/contract', label: t('nav.contract') },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-[#2e5453] shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20 md:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/logo.png" 
              alt="Children Planet" 
              className="h-14 md:h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-2">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path}>
                <Button
                  variant={isActive(link.path) ? 'default' : 'ghost'}
                  className={`font-medium transition-all ${
                    isActive(link.path)
                      ? 'bg-[#96ba1e] text-[#2e5453] hover:bg-[#a8cc32]'
                      : 'text-[#96ba1e] hover:bg-[#3d6a68] hover:text-white'
                  }`}
                >
                  {link.label}
                </Button>
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-3">
            <LanguageSwitcher />
            <Link to="/contact">
              <Button variant="outline" className="border-[#96ba1e] text-[#96ba1e] hover:bg-[#3d6a68]">
                {t('nav.contact')}
              </Button>
            </Link>
            <Link to="/booking">
              <Button className="bg-[#96ba1e] hover:bg-[#a8cc32] text-[#2e5453] font-bold">
                {t('nav.bookNow')}
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg text-[#96ba1e] hover:bg-[#3d6a68]"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-[#3d6a68]">
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                >
                  <Button
                    variant={isActive(link.path) ? 'default' : 'ghost'}
                    className={`w-full justify-start font-medium ${
                      isActive(link.path)
                        ? 'bg-[#96ba1e] text-[#2e5453] hover:bg-[#a8cc32]'
                        : 'text-[#96ba1e] hover:bg-[#3d6a68] hover:text-white'
                    }`}
                  >
                    {link.label}
                  </Button>
                </Link>
              ))}
              <div className="pt-4 space-y-2">
                <div className="px-4 py-2">
                  <LanguageSwitcher />
                </div>
                <Link to="/contact" onClick={() => setIsOpen(false)}>
                  <Button variant="outline" className="w-full border-[#96ba1e] text-[#96ba1e] hover:bg-[#3d6a68]">
                    {t('nav.contact')}
                  </Button>
                </Link>
                <Link to="/booking" onClick={() => setIsOpen(false)}>
                  <Button className="w-full bg-[#96ba1e] hover:bg-[#a8cc32] text-[#2e5453] font-bold">
                    {t('nav.bookNow')}
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
